// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function submitForgotPassword(email) {
  return {
    type: types.SUBMIT_FORGOT_PASSWORD,
    email,
  };
}

export function submitForgotPasswordSuccess() {
  return {
    type: types.SUBMIT_FORGOT_PASSWORD_SUCCESS,
  };
}

export function submitForgotPasswordFailed(data) {
  return {
    type: types.SUBMIT_FORGOT_PASSWORD_FAILED,
    ...data,
  };
}


export function changeField(value, field) {
  return {
    type: types.FORGOT_PASSWORD_CHANGE_FIELD,
    value,
    field
  };
}

export function resetForm() {
  return {
    type: types.FORGOT_PASSWORD_RESET_FORM,
  };
}
